import { render, staticRenderFns } from "./PlayerClientIdentities.vue?vue&type=template&id=46dca180&scoped=true&"
import script from "./PlayerClientIdentities.vue?vue&type=script&lang=js&"
export * from "./PlayerClientIdentities.vue?vue&type=script&lang=js&"
import style0 from "./PlayerClientIdentities.vue?vue&type=style&index=0&id=46dca180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dca180",
  null
  
)

export default component.exports